export default __webpack_public_path__ + "static/media/carrot.21ddfaca.png";